<template>
  <icon-button data-toggle="modal" :data-target="modalTarget" :btnClass="btnClass" :icon="icon" />
</template>

<script>
import IconButton from "@/components/Buttons/IconButton.vue";

export default {
  name: "modal-icon-button",
  components: {
    "icon-button": IconButton
  },
  props: {
    icon: String,
    modalTarget: String,
    btnClass: {
      type: String,
      default: "btn-primary"
    }
  }
};
</script>